import React from 'react';
import PropTypes from 'prop-types';

const FiletypeSpreadsheetPath = ({ fill = '#19804D' }) => {
  return (
    <path
      fill={fill}
      d="M25.316 9.681c.382.365.684 1.082.684 1.609v15.084c0 .898-.763 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4h10.717c.539 0 1.261.293 1.639.654l5.259 5.027zM11 22.506c0 .268.228.494.51.494h8.98c.282 0 .51-.221.51-.494V10.494a.505.505 0 0 0-.51-.494h-8.98a.502.502 0 0 0-.51.494v12.012zm1-2.261a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm4.5 0a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm-4.5-3a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm4.5 0a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm-4.5-3a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm4.5 0a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm-4.5-3a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51zm4.5 0a.25.25 0 0 1 .252-.245h2.996c.139 0 .252.107.252.245v1.51a.25.25 0 0 1-.252.245h-2.996a.248.248 0 0 1-.252-.245v-1.51z"
    />
  );
};

FiletypeSpreadsheetPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypeSpreadsheetPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-spreadsheet.jsx